var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-block"
  }, [_c('h3', {
    staticClass: "text-title"
  }, [_vm._v(_vm._s(_vm.title))]), _c('p', {
    staticClass: "text-content"
  }, [_vm._v(_vm._s(_vm.content))])]);
}
var staticRenderFns = []

export { render, staticRenderFns }